import { render, staticRenderFns } from "./port-add-or-update.vue?vue&type=template&id=1532d1ee&"
import script from "./port-add-or-update.vue?vue&type=script&lang=js&"
export * from "./port-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./port-add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports